import { motion } from "framer-motion";
import { Heart } from "lucide-react";
import { Star } from "./Star";
import { useI18n } from "@/context/LanguageContext";

export const DressCodeKidLess = () => {
  const { t } = useI18n();
  return (
    <section id="dresscode" data-testid="dress-kidless-section" className="bg-[#FFF7F1] py-16 md:py-36">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8 grid grid-cols-12 gap-5 md:gap-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          data-testid="dress-code-card"
          className="col-span-12 md:col-span-7 bg-[#7AD5DC] border-2 border-[#141518] shadow-hard p-8 md:p-12 relative overflow-hidden"
        >
          <Star size={140} className="absolute -top-8 -right-8 text-[#141518]/10" spin />
          <div className="font-condensed font-bold uppercase tracking-[0.25em] text-sm md:text-base text-[#F0311B]">{t.dress.eyebrow}</div>
          <h3 className="mt-3 font-display font-bold text-[10vw] sm:text-5xl md:text-6xl leading-[0.95] text-[#141518]">
            {t.dress.titleA} <span className="italic">{t.dress.titleB}</span>
          </h3>
          <p className="mt-6 text-[#141518]/80 text-base md:text-lg leading-relaxed max-w-2xl">{t.dress.text}</p>
          <div className="mt-8 flex flex-wrap gap-2">
            {t.dress.tags.map((tag) => (
              <span key={tag} className="bg-white px-3 py-1.5 border-2 border-[#141518] text-xs font-condensed uppercase tracking-[0.2em] text-[#141518]">{tag}</span>
            ))}
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.1 }}
          data-testid="kidless-card"
          className="col-span-12 md:col-span-5 bg-[#F0311B] text-white p-8 md:p-12 relative overflow-hidden border-2 border-[#141518] shadow-hard"
        >
          <Heart size={140} className="absolute -bottom-6 -right-6 text-white/15" />
          <div className="font-condensed font-bold uppercase tracking-[0.25em] text-sm md:text-base">{t.kidless.eyebrow}</div>
          <h3 className="mt-3 font-display font-bold text-[12vw] sm:text-5xl md:text-6xl leading-[0.95]">{t.kidless.title}</h3>
          <p className="mt-6 text-white/90 text-base leading-relaxed">{t.kidless.text}</p>
        </motion.div>
      </div>
    </section>
  );
};
